/* eslint-disable jsx-a11y/anchor-has-content,react/no-unused-prop-types,jsx-a11y/no-noninteractive-element-interactions,no-unused-vars */
import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { t } from 'utils/translates';

import {
  selectFieldUserIds,
  addUserModel
} from 'mt-react-common/modules/messenger/reducers/static/forms/createGroupRoom/createGroupRoomForm';

const createRoomFormRN = 'messengerModule.forms.createRoomForm';

// eslint-disable-next-line react/prefer-stateless-function
class AddUserItem extends Component {
  getMarkers = () => {
    const markers = [];
    if (this.props.item.isMyReferrer) markers.push(t('Мой реферер'));
    if (this.props.item.isMyReferral) markers.push(t('Мой реферал'));
    if (this.props.item.concatRoles) markers.push(t('Администрация'));
    return markers.join(' | ');
  };

  render() {
    return (
      <tr>
        <td>
          <div className="media">
            <div className="media-left">
              <img
                alt=""
                className="media-object avatar avatar-xs"
                src={this.props.item.profile.avatarPath}
              />
            </div>
            <div className="media-body media-middle">
              <div className="text-caption">
                <span>{this.props.item.username}</span>{' '}
                <span className="text-muted">{this.getMarkers()}</span>
              </div>
            </div>
          </div>
        </td>
        <td className="text-right">
          <button
            className="btn btn-default btn-sm"
            type="submit"
            disabled={this.props.fieldUserIds.value.includes(
              this.props.item.id.toString()
            )}
            onClick={e => {
              this.props.addUserModel(this.props.item);
            }}
          >
            <i className="fa fa-plus-circle" /> {t('Добавить')}
          </button>
        </td>
      </tr>
    );
  }
}

AddUserItem.propTypes = {
  item: PropTypes.shape({
    id: PropTypes.number,
    username: PropTypes.string,
    concatRoles: PropTypes.string,
    isMyReferrer: PropTypes.bool,
    isMyReferral: PropTypes.bool,
    profile: PropTypes.shape({
      avatarPath: PropTypes.string
    })
  }).isRequired,

  // CONNECT
  addUserModel: PropTypes.func.isRequired,
  fieldUserIds: PropTypes.shape({
    value: PropTypes.any,
    errors: PropTypes.array.isRequired
  }).isRequired
};

const mapStateToProps = state => ({
  fieldUserIds: selectFieldUserIds(state, createRoomFormRN)
});

const mapDispatchToProps = dispatch => ({
  addUserModel: value => dispatch(addUserModel(createRoomFormRN, value))
});

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(AddUserItem);



// WEBPACK FOOTER //
// ./src/components/Messenger/content/MessengerGroupRoomFormPopUp/common/AddUserItem.js